import { render, staticRenderFns } from "./GetQr.vue?vue&type=template&id=cbebafa4&"
import script from "./GetQr.vue?vue&type=script&lang=js&"
export * from "./GetQr.vue?vue&type=script&lang=js&"
import style0 from "./GetQr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GetQr.vue"
export default component.exports